import moment from 'moment';

function getCurrentTime(format) {
  format = format || 'YYYY/MM/DD';
  let time = initCurrentTime();
  return moment(time).format(format);
}

function initCurrentTime() {
  let globalData = getApp().globalData;
  let systemTime = globalData.SystemTime;
  let localTime = globalData.LocalTime;
  if (systemTime && localTime) {
    let currentTime = moment(new Date()).toDate();
    let systemStamp = moment(new Date(systemTime)).valueOf();
    let stamp = Date.parse(currentTime) - Date.parse(localTime);
    return moment(systemStamp + stamp);
  } else {
    let date = new Date();
    return moment(date);
  }
}

//获取当前时间与传入时间的时间差值
function getTimeDiffByEndTime(stime, etime, type) {
  return moment(etime).diff(moment(stime), type);
}

function formatDateTime(time, format) {
  return moment(time).format(format);
}

function diffDate(startDate, endDate, type) {
  if (startDate.indexOf('-') >= 0 && startDate.indexOf('T') < 0) {
    startDate = moment(startDate.replace(/-/g, '/')).format('YYYY/MM/DD');
  } else {
    startDate = moment(startDate).format('YYYY/MM/DD');
  }
  if (endDate.indexOf('-') >= 0 && endDate.indexOf('T') < 0) {
    endDate = moment(endDate.replace(/-/g, '/')).format('YYYY/MM/DD');
  } else {
    endDate = moment(endDate).format('YYYY/MM/DD');
  }
  return moment(endDate).diff(moment(startDate), type);
}

function getWeek(date, systemDate) {
  if (!date) {
    return '';
  }
  var Week = ['日', '一', '二', '三', '四', '五', '六'];
  let weekStr = '';
  if (typeof date == 'String' || typeof date == 'string') {
    weekStr = Week[new Date(date.replace(/-/g, '/')).getDay()];
  } else {
    weekStr = Week[date.getDay()];
  }
  date = formatDateTime(date, 'YYYY/MM/DD');
  systemDate = formatDateTime(systemDate, 'YYYY/MM/DD');
  let tomorrow = formatDateTime(add(systemDate, 1, 'days'), 'YYYY/MM/DD');
  let aftertomorrow = formatDateTime(add(systemDate, 2, 'days'), 'YYYY/MM/DD');
  if (systemDate == date) {
    return '今天';
  } else if (date == tomorrow) {
    return '明天';
  } else if (date == aftertomorrow) {
    return '后天';
  }
  return '周' + weekStr;
}

function add(date, count, type) {
  return moment(date).add(count, type).format('YYYY-MM-DD');
}

export default {
  getCurrentTime,
  formatDateTime,
  diffDate,
  moment,
  getWeek,
  add,
  getTimeDiffByEndTime,
  initCurrentTime,
};
